import { SearchtoolboxService } from './../../_services/searchtoolbox.service';
import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import {Router} from '@angular/router';
import { LoadingService } from 'src/app/_services/loading.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class LoadingScreenInterceptor implements HttpInterceptor {

  activeRequests: number = 0;
  devUrl = environment.backendurl

  /**
   * URLs for which the loading screen should not be enabled
   */
  skippUrls = [
      this.devUrl + '/personsearch/aggregates',
      this.devUrl + '/openai/companyinsightssummary',
      this.devUrl + '/openai/talentinsightssummary',
      this.devUrl + '/openai/quicksearchsummary',
      this.devUrl + "/related_data",
      this.devUrl + '/candidate/bulkgrab',
      this.devUrl + '/candidate/bulkextractionstatus',
      this.devUrl  + '/companypages/enrichdetails',
      this.devUrl  + '/searchtoolbox/autocomplete_dropdown_data',
      this.devUrl  + '/searchtoolbox/related_data',
      this.devUrl + '/gettalentpoollist',
      this.devUrl + '/searchtoolbox/bulkgrab',
      this.devUrl + '/createtalentpool',
      this.devUrl + '/paymentflow/fetchcurrentplandetails',
      this.devUrl + '/personsearch/detailsfrompdlids',
      this.devUrl + '/personsearch/recentcompanyhires',
      this.devUrl + '/personsearch/recentcompanyattrition',
      this.devUrl + '/personsearch/search/name/duplicate',
      this.devUrl + '/openai/similar-job-titles',,
      this.devUrl + '/personsearch/previewcontactdetails',
      this.devUrl + '/personsearch/typeaheads',
      this.devUrl + '/personsearch/companylogo',
      this.devUrl + '/getcandidatedetails',
      this.devUrl + '/candidate/fetchcvdetails',
      this.devUrl + '/paymentflow/fetchcurrentplandetails',
      this.devUrl + '/candidate/fetchexistingcontactdetails',
      this.devUrl + '/candidate/getcandidateactivity',
      this.devUrl + '/candidate/tags',
      this.devUrl + '/personsearch/searchhistory',
      this.devUrl + '/personsearch/savedsearchhistory',
      this.devUrl + '/personsearch/recommendcandidates',
      this.devUrl + '/personsearch/companywinningtalentfrom',
      this.devUrl + '/personsearch/companylosingtalentto',
      this.devUrl + '/personsearch/changedjobscount',
      this.devUrl + '/openai/similar-job-titles',
      this.devUrl + '/openai/unified'
  ];


  constructor(private loadingservice: LoadingService, private router: Router,) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let displayLoadingScreen = true;
    
   for (const skippUrl of this.skippUrls) {
      if (new RegExp(skippUrl).test(request.url)) {
        displayLoadingScreen = false;
        break;
      }
    }

    if (displayLoadingScreen) {
      if (this.activeRequests === 0) {
        this.loadingservice.startLoading();
      }
      this.activeRequests++;

      return next.handle(request).pipe(
        finalize(() => {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            this.loadingservice.stopLoading();
          }
        })
      )
    } else {
      return next.handle(request);
    }
  };
}